import { CartArrowUpIcon } from './CartArrowUpIcon';

/**
 * author: Simran
 * id 8ED82219-BC37-41C0-9012-E316AB7BD809
 * name cart-arrow-up
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cart-arrow-up.svg
 * tags
 * - Shopping 
 */
export const ShoppingCartArrowUpIcon = CartArrowUpIcon;
export default ShoppingCartArrowUpIcon